const unitSort = (sumUnit: { [key: string]: number }): [string, number][] => {
  return Object.entries(sumUnit)
    .sort((a, b) => b[1] - a[1])
    .filter((a) => a[1] !== 0);
};

export default unitSort;
